import { render, staticRenderFns } from "./DeathsChart.vue?vue&type=template&id=63ebbbc8&"
import script from "./DeathsChart.vue?vue&type=script&lang=js&"
export * from "./DeathsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports